import React, { Fragment, useState, useEffect } from "react";
import { Redirect, Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getSettings, updateSetting } from "../../actions/setting";
import { clearMsg, logout, deleteAccount } from "../../actions/auth";
import { getBlockedUsers } from "../../actions/blockuser";
import { getProfileById } from "../../actions/profile";

import LoggedInNav from "../layout/IME/LoggedInNav";
import LoggedInNavRed from "../layout/IME/LoggedInNavRed";
import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";
import GreenLogo from "../layout/Innovators/GreenLogo";
import IMEAltLogo from "../layout/IME/IMEAltLogo";
import BlockedUserItem from "../layout/IME/BlockedUserItem";
import UnblockUserSettings from "../layout/IME/UnblockUserSettings";
import DeleteAccount from "../layout/IME/DeleteAccount";
import MessageModal from "../layout/IME/MessageModal";
import MinimumNav from "../layout/IME/MinimumNav";

const Settings = ({
  match,
  auth: { user, msg },
  profile: { profile },
  isAuthenticated,
  setting: { settings },
  blockuser: { blockedusers },
  updateSetting,
  getSettings,
  getBlockedUsers,
  getProfileById,
  logout,
  clearMsg,
  deleteAccount,
}) => {
  const [showDeleteAccount, setShowDeleteAccount] = useState(false);
  const [view, setView] = useState({
    profile: true,
    notifications: false,
    privacy: false,
    blockedusers: false,
  });
  const [UnblockUser, setUnblockUser] = useState({
    request: false,
    confirm: false,
    role: "",
    channelid: "",
    avatar: "",
    firstname: "",
    lastname: "",
    companyname: "",
    jobtitle: "",
    location: {},
  });

  const [profileDropDown, setprofileDropDown] = useState(false);

  useEffect(() => {
    getSettings(match.params.channelid);
    getProfileById(match.params.channelid);
    getBlockedUsers(match.params.channelid);
  }, [getSettings, getProfileById]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (
    isAuthenticated &&
    user &&
    user.channelid !== match.params.channelid
  ) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {UnblockUser.request && (
        <UnblockUserSettings
          setUnblockUser={setUnblockUser}
          UnblockUser={UnblockUser}
        />
      )}
      {showDeleteAccount && (
        <DeleteAccount
          user={user}
          setShowDeleteAccount={setShowDeleteAccount}
          deleteAccount={deleteAccount}
        />
      )}
      {msg && msg !== "" && (
        <MessageModal user={user} msg={msg} clearMsg={clearMsg} />
      )}
      {user && user.role === "innovator" && (
        <div>
          <MinimumNav user={user} />
          {/* <LoggedInNav /> */}
          {/* <section className="full-content">
            <nav className="login-nav background-dark-black border-bottom grey">
              {isAuthenticated && (
                <div className="user-container">
                  <div className="user-avi-container">
                    <img
                      src={`/uploads/avatars/${user && user.avatar}`}
                      className="user-avi"
                    />
                  </div>
                  <div className="user-name-info-container">
                    <p className="user-name-info">
                      {" "}
                      Hi, {user && user.firstname}!
                    </p>
                    <div className="arrows-up-down">
                      {!profileDropDown && (
                        <i
                          className={`fas fa-angle-up mx-5 ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                          onClick={() => setprofileDropDown(true)}
                        ></i>
                      )}
                      {profileDropDown && (
                        <i
                          className={`fas fa-angle-down mx-5 ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                          onClick={() => setprofileDropDown(false)}
                        ></i>
                      )}
                    </div>
                  </div>
                  {profileDropDown && (
                    <div className="campaign-profile-drop-down">
                      {user.channelid === "roland" && (
                        <Link to="/liveonime/roland/live">
                          <div className="profile-drop-container">
                            <i
                              className={`fa-solid fa-tower-broadcast fa-lg drop-down-icon ${
                                user && user.role === "innovator"
                                  ? "green"
                                  : user && user.role === "mentor"
                                  ? "red"
                                  : "blue"
                              }`}
                            ></i>
                            <p className="drop-down-text">Stream Manager</p>
                          </div>
                        </Link>
                      )}
                      {user.channelid === "roland" && (
                        <Link to="/roland/dashboard">
                          <div className="profile-drop-container">
                            <i
                              className={`fa-solid fa-chart-simple fa-lg drop-down-icon ${
                                user && user.role === "innovator"
                                  ? "green"
                                  : user && user.role === "mentor"
                                  ? "red"
                                  : "blue"
                              }`}
                            ></i>
                            <p className="drop-down-text">Dashboard</p>
                          </div>
                        </Link>
                      )}
                      <Link to="/">
                        <div className="profile-drop-container">
                          <i
                            className={`fa-solid fa-house-chimney fa-lg drop-down-icon ${
                              user && user.role === "innovator"
                                ? "green"
                                : user && user.role === "mentor"
                                ? "red"
                                : "blue"
                            }`}
                          ></i>
                          <p className="drop-down-text">Home</p>
                        </div>
                      </Link>
                      <Link to={`/'roland`}>
                        <div className="profile-drop-container">
                          <i
                            className={`fa-solid fa-users fa-lg drop-down-icon ${
                              user && user.role === "innovator"
                                ? "green"
                                : user && user.role === "mentor"
                                ? "red"
                                : "blue"
                            }`}
                          ></i>
                          <p className="drop-down-text">Community Posts</p>
                        </div>
                      </Link>
                      {isAuthenticated && !user.banned && (
                        <Link to={`/${user.channelid}/edit`}>
                          <div className="profile-drop-container">
                            <i
                              className={`fa-regular fa-circle-user fa-lg drop-down-icon ${
                                user && user.role === "innovator"
                                  ? "green"
                                  : user && user.role === "mentor"
                                  ? "red"
                                  : "blue"
                              }`}
                            ></i>
                            <p className="drop-down-text">Edit Profile</p>
                          </div>
                        </Link>
                      )}
                      <Link to={`/${user && user.channelid}/purchases`}>
                        <div className="profile-drop-container">
                          <i
                            className={`fas fa-dollar-sign fa-lg drop-down-icon ${
                              user && user.role === "innovator"
                                ? "green"
                                : user && user.role === "mentor"
                                ? "red"
                                : "blue"
                            }`}
                          ></i>
                          <p className="drop-down-text">Purchases</p>
                        </div>
                      </Link>
                      <Link to={`/${user.channelid}/settings`}>
                        <div className="profile-drop-container">
                          <i
                            className={`fas fa-cog fa-lg drop-down-icon ${
                              user && user.role === "innovator"
                                ? "green"
                                : user && user.role === "mentor"
                                ? "red"
                                : user && user.role === "employer"
                                ? "blue"
                                : ""
                            }`}
                          ></i>
                          <p className="drop-down-text">Settings</p>
                        </div>
                      </Link>
                      <Link to="/agreement">
                        <div className="profile-drop-container">
                          <i
                            className={`fa-solid fa-file-contract fa-lg drop-down-icon ${
                              user && user.role === "innovator"
                                ? "green"
                                : user && user.role === "mentor"
                                ? "red"
                                : "blue"
                            }`}
                          ></i>
                          <p className="drop-down-text">Terms of Agreement</p>
                        </div>
                      </Link>
                      <div
                        className="profile-drop-container"
                        onClick={() => {
                          logout();
                          setprofileDropDown(false);
                        }}
                        href="#!"
                      >
                        <i
                          className={`fas fa-door-closed fa-lg drop-down-icon ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        ></i>
                        <p className="drop-down-text">Logout</p>
                      </div>
                    </div>
                  )}
                </div>
              )}
              <Link to="/">
                <div className="center-nav">
                  <div className="index-logo-alt">
                    <GreenLogo />
                  </div>
                  <i className="fas fa-trademark green fa-sm mt-10"></i>
                  <div className="index-logo">
                    <IMEAltLogo />
                  </div>
                </div>
              </Link>
              <div className="buttons hidden-container">
                <Link to="/employers">
                  <div className="action-items-index green">
                    <div className="action-button-index green">
                      <i className="fas fa-user action-icon-index fa-lg green"></i>
                    </div>
                    <p className="action-text-index green">Employers</p>
                  </div>
                </Link>
                <Link to="/mentors">
                  <div className="action-items-index green">
                    <div className="action-button-index green">
                      <i className="fas fa-user action-icon-index fa-lg green"></i>
                    </div>
                    <p className="action-text-index green">Mentors</p>
                  </div>
                </Link>
              </div>
            </nav>
          </section> */}
          <div className="flex-all-content-fixed">
            <section className="settings-main-body">
              <div className="active-view">
                <div
                  onClick={() =>
                    setView({
                      profile: true,
                      notifications: false,
                      privacy: false,
                      blockedusers: false,
                    })
                  }
                  className="section-title green"
                >
                  Profile
                  {view.profile && (
                    <i className="far fa-check-circle mx-5 green"></i>
                  )}
                </div>
                <div
                  onClick={() =>
                    setView({
                      profile: false,
                      notifications: true,
                      privacy: false,
                      blockedusers: false,
                    })
                  }
                  className="section-title green"
                >
                  Notifications
                  {view.notifications && (
                    <i className="far fa-check-circle mx-5 green"></i>
                  )}
                </div>
                <div
                  onClick={() =>
                    setView({
                      profile: false,
                      notifications: false,
                      privacy: true,
                      blockedusers: false,
                    })
                  }
                  className="section-title green"
                >
                  Privacy
                  {view.privacy && (
                    <i className="far fa-check-circle mx-5 green"></i>
                  )}
                </div>
                <div
                  onClick={() =>
                    setView({
                      profile: false,
                      notifications: false,
                      privacy: false,
                      blockedusers: true,
                    })
                  }
                  className="section-title green"
                >
                  Blocked Users
                  {view.blockedusers && (
                    <i className="far fa-check-circle mx-5 green"></i>
                  )}
                </div>
              </div>
              <div className="option-setting-container green">
                <div className="option-settings">
                  {view.profile && (
                    <div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Online Status</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select who can view your online status
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.onlinestatus &&
                                settings.onlinestatus.friends
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"settings_friends"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.onlinestatus &&
                                    settings.onlinestatus.friends
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Friends
                            </li>
                            <li
                              className={
                                settings.onlinestatus &&
                                settings.onlinestatus.anyone
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"settings_anyone"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.onlinestatus &&
                                    settings.onlinestatus.anyone
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Anyone
                            </li>
                            <li
                              className={
                                settings.onlinestatus &&
                                settings.onlinestatus.hidden
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"settings_hidden"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.onlinestatus &&
                                    settings.onlinestatus.hidden
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Hidden
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">
                            Auto-Renew Subscriptions
                          </div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select whether or not you would like all your
                              active subscriptions to auto-renew
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.autorenew && settings.autorenew.renew
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"settings_renew"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.autorenew &&
                                    settings.autorenew.renew
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.autorenew && !settings.autorenew.renew
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"settings_not_renew"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.autorenew &&
                                    !settings.autorenew.renew
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Delete Account</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              There is no turning back! You will lose all your
                              content!
                            </p>
                          </div>
                        </div>
                        <div
                          onClick={() => setShowDeleteAccount(true)}
                          className="setting-option-choices"
                        >
                          <ul className="option-choices">
                            <li className="option-choice-alt white">
                              <div className="check-text-container">
                                <i className="far fa-times-circle mx-5 x red"></i>
                              </div>
                              Delete Account
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                  {view.notifications && (
                    <div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Live Streams</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Be notified when users you follow or subscribe to
                              go live
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.livestreams
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_livestreams"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.livestreams
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.livestreams
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_livestreams"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.livestreams
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Mentions</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Be alerted when a user mentions you in a live chat
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.mentions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_mentions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.mentions
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.mentions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_mentions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.mentions
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">
                            Gifted Subscriptions and Courses
                          </div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Be notified when you are gifted a subscription or
                              course
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.giftedsubscriptions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_giftedsubscriptions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.giftedsubscriptions
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.giftedsubscriptions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_giftedsubscriptions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.giftedsubscriptions
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Friend requests</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Be notified when you receive a new friend request,
                              or your friend request was accepted
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.friendrequests
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_friendrequests"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.friendrequests
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.friendrequests
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_friendrequests"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.friendrequests
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">
                            Expiring Subscriptions
                          </div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Receive notification for an expiring subscription
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.expiringsubscriptions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_expiringsubscriptions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.expiringsubscriptions
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.expiringsubscriptions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_expiringsubscriptions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications
                                      .expiringsubscriptions
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Shared Article</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Receive notification when a user shares an article
                              with you
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.sharedarticles
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_sharedarticles"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.sharedarticles
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.sharedarticles
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_sharedarticles"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.sharedarticles
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">New Follower</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Receive notification when you gain a new follower
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.newfollower
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_newfollower"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.newfollower
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.newfollower
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_newfollower"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.newfollower
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Discussion Invite</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Receive a notification when you are invited to a
                              discussion
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.discussioninvite
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_discussioninvite"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.discussioninvite
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.discussioninvite
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_discussioninvite"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.discussioninvite
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                  {view.privacy && (
                    <div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Community Type</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select who can join and post in your community
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                profile && profile.publicprofile
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_profiletype_public"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    profile && profile.publicprofile
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Public
                            </li>
                            <li
                              className={
                                profile && profile.privateprofile
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_profiletype_private"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    profile && profile.privateprofile
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Private
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">
                            Two Factor Authentication (Recommended)
                          </div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Choose to require additional validation before
                              accessing your account.{" "}
                              <span className="red bold">
                                This setting is highly recommended.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.privacy && settings.privacy.TwoFA
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_TwoFA"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy && settings.privacy.TwoFA
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.privacy && !settings.privacy.TwoFA
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_not_TwoFA"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy && !settings.privacy.TwoFA
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Employer Messages</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select whether or not employers can message you
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.privacy &&
                                settings.privacy.employermessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_employermessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    settings.privacy.employermessages
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.privacy &&
                                !settings.privacy.employermessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_not_employermessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    !settings.privacy.employermessages
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Mentor Messages</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select whether or not mentor can message you
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.privacy &&
                                settings.privacy.mentormessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_mentormessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    settings.privacy.mentormessages
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.privacy &&
                                !settings.privacy.mentormessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_not_mentormessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    !settings.privacy.mentormessages
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Follower Messages</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select whether or not followers can message you
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.privacy &&
                                settings.privacy.followermessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_followermessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    settings.privacy.followermessages
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.privacy &&
                                !settings.privacy.followermessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_not_followermessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    !settings.privacy.followermessages
                                      ? "fas fa-check mx-5 green"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                  {view.blockedusers && (
                    <div>
                      {blockedusers && blockedusers.length > 0 && (
                        <div className="user-search-container">
                          <div className="article-search-container">
                            <form action="" className="trending-form-flex">
                              <div className="label-input">
                                <label
                                  htmlFor=""
                                  className="trending-labels green"
                                >
                                  Search
                                  <i className="fas fa-search green mx-5"></i>
                                </label>
                                <div className="input-drop-down">
                                  <div className="search-input-hidden">
                                    <input
                                      className="search-input-style"
                                      type="text"
                                      name="mentors"
                                      placeholder="Enter User Name..."
                                    />
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      )}
                      <section className="setting-friends-section">
                        <div className="setting-friend-results">
                          {blockedusers &&
                            blockedusers.map((friend) => (
                              <BlockedUserItem
                                key={friend._id}
                                friend={friend}
                                setUnblockUser={setUnblockUser}
                              />
                            ))}
                          {blockedusers && blockedusers.length <= 0 && (
                            <p className="empty-content-blocked-users green">
                              No Blocked Users
                            </p>
                          )}
                        </div>
                      </section>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </div>
        </div>
      )}
      {user && user.role === "mentor" && (
        <div>
          {/* <LoggedInNavRed /> */}
          <MinimumNav user={user} />
          <div className="flex-all-content-fixed">
            <section className="settings-main-body">
              <div className="active-view">
                <div
                  onClick={() =>
                    setView({
                      profile: true,
                      notifications: false,
                      privacy: false,
                      blockedusers: false,
                    })
                  }
                  className="section-title red"
                >
                  Profile
                  {view.profile && (
                    <i className="far fa-check-circle mx-5 red"></i>
                  )}
                </div>
                <div
                  onClick={() =>
                    setView({
                      profile: false,
                      notifications: true,
                      privacy: false,
                      blockedusers: false,
                    })
                  }
                  className="section-title red"
                >
                  Notifications
                  {view.notifications && (
                    <i className="far fa-check-circle mx-5 red"></i>
                  )}
                </div>
                <div
                  onClick={() =>
                    setView({
                      profile: false,
                      notifications: false,
                      privacy: true,
                      blockedusers: false,
                    })
                  }
                  className="section-title red"
                >
                  Privacy
                  {view.privacy && (
                    <i className="far fa-check-circle mx-5 red"></i>
                  )}
                </div>
                <div
                  onClick={() =>
                    setView({
                      profile: false,
                      notifications: false,
                      privacy: false,
                      blockedusers: true,
                    })
                  }
                  className="section-title red"
                >
                  Blocked Users
                  {view.blockedusers && (
                    <i className="far fa-check-circle mx-5 red"></i>
                  )}
                </div>
              </div>
              <div className="option-setting-container">
                <div className="option-settings">
                  {view.profile && (
                    <div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Online Status</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select who can view your online status
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.onlinestatus &&
                                settings.onlinestatus.friends
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"settings_friends"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.onlinestatus &&
                                    settings.onlinestatus.friends
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Friends
                            </li>
                            <li
                              className={
                                settings.onlinestatus &&
                                settings.onlinestatus.anyone
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"settings_anyone"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.onlinestatus &&
                                    settings.onlinestatus.anyone
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Anyone
                            </li>
                            <li
                              className={
                                settings.onlinestatus &&
                                settings.onlinestatus.hidden
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"settings_hidden"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.onlinestatus &&
                                    settings.onlinestatus.hidden
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Hidden
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">
                            Auto-Renew Subscriptions
                          </div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select whether or not you would like all your
                              active subscriptions to auto-renew
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.autorenew && settings.autorenew.renew
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"settings_renew"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.autorenew &&
                                    settings.autorenew.renew
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.autorenew && !settings.autorenew.renew
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"settings_not_renew"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.autorenew &&
                                    !settings.autorenew.renew
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Delete Account</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              There is no turning back! You will lose all your
                              content!
                            </p>
                          </div>
                        </div>
                        <div
                          onClick={() => setShowDeleteAccount(true)}
                          className="setting-option-choices"
                        >
                          <ul className="option-choices">
                            <li className="option-choice-alt white">
                              <div className="check-text-container">
                                <i className="far fa-times-circle mx-5 x red"></i>
                              </div>
                              Delete Account
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                  {view.notifications && (
                    <div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Live Streams</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Be notified when users you follow or subscribe to
                              go live
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.livestreams
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_livestreams"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.livestreams
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.livestreams
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_livestreams"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.livestreams
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Mentions</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Be alerted when a user mentions you in a live chat
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.mentions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_mentions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.mentions
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.mentions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_mentions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.mentions
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">
                            Gifted Subscriptions and Courses
                          </div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Be notified when you are gifted a subscription or
                              course
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.giftedsubscriptions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_giftedsubscriptions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.giftedsubscriptions
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.giftedsubscriptions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_giftedsubscriptions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.giftedsubscriptions
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Friend requests</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Be notified when you receive a new friend request,
                              or your friend request was accepted
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.friendrequests
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_friendrequests"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.friendrequests
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.friendrequests
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_friendrequests"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.friendrequests
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">
                            Expiring Subscriptions
                          </div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Receive notification for an expiring subscription
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.expiringsubscriptions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_expiringsubscriptions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.expiringsubscriptions
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.expiringsubscriptions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_expiringsubscriptions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications
                                      .expiringsubscriptions
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Shared Article</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Receive notification when a user shares an article
                              with you
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.sharedarticles
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_sharedarticles"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.sharedarticles
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.sharedarticles
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_sharedarticles"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.sharedarticles
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">New Subscriber</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Receive notification when you gain a new
                              subscriber
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.newsubscriber
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_newsubscriber"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.newsubscriber
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.newsubscriber
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_newsubscriber"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.newsubscriber
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">New Follower</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Receive notification when you gain a new follower
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.newfollower
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_newfollower"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.newfollower
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.newfollower
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_newfollower"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.newfollower
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Course Purchase</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Receive notification when a user purchases your
                              course
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.coursepurchased
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_course_purchased"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications.coursepurchased
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.coursepurchased
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_course_purchased"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.coursepurchased
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                  {view.privacy && (
                    <div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Community Type</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select who can join and post in your community
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                profile && profile.publicprofile
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_profiletype_public"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    profile && profile.publicprofile
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Public
                            </li>
                            <li
                              className={
                                profile && profile.privateprofile
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_profiletype_private"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    profile && profile.privateprofile
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Private
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">
                            Two Factor Authentication (Recommended)
                          </div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Choose to require additional validation before
                              accessing your account.{" "}
                              <span className="red bold">
                                This setting is highly recommended.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.privacy && settings.privacy.TwoFA
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_TwoFA"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy && settings.privacy.TwoFA
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.privacy && !settings.privacy.TwoFA
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_not_TwoFA"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy && !settings.privacy.TwoFA
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Employer Messages</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select whether or not employers can message you
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.privacy &&
                                settings.privacy.employermessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_employermessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    settings.privacy.employermessages
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.privacy &&
                                !settings.privacy.employermessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_not_employermessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    !settings.privacy.employermessages
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Mentor Messages</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select whether or not mentor can message you
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.privacy &&
                                settings.privacy.mentormessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_mentormessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    settings.privacy.mentormessages
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.privacy &&
                                !settings.privacy.mentormessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_not_mentormessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    !settings.privacy.mentormessages
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">
                            Subscriber Messages
                          </div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select whether or not subscribers can message you
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.privacy &&
                                settings.privacy.subscribermessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_subscribermessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    settings.privacy.subscribermessages
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.privacy &&
                                !settings.privacy.subscribermessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_not_subscribermessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    !settings.privacy.subscribermessages
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Follower Messages</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select whether or not followers can message you
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.privacy &&
                                settings.privacy.followermessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_followermessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    settings.privacy.followermessages
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.privacy &&
                                !settings.privacy.followermessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_not_followermessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    !settings.privacy.followermessages
                                      ? "fas fa-check mx-5 red"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                  {view.blockedusers && (
                    <div>
                      {blockedusers && blockedusers.length > 0 && (
                        <div className="user-search-container">
                          <div className="article-search-container">
                            <form action="" className="trending-form-flex">
                              <div className="label-input">
                                <label
                                  htmlFor=""
                                  className="trending-labels red"
                                >
                                  Search
                                  <i className="fas fa-search red mx-5"></i>
                                </label>
                                <div className="input-drop-down">
                                  <div className="search-input-hidden">
                                    <input
                                      className="search-input-style"
                                      type="text"
                                      name="mentors"
                                      placeholder="Enter User Name..."
                                    />
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      )}
                      <section className="setting-friends-section">
                        <div className="setting-friend-results">
                          {blockedusers &&
                            blockedusers.map((friend) => (
                              <BlockedUserItem
                                key={friend._id}
                                friend={friend}
                                setUnblockUser={setUnblockUser}
                              />
                            ))}
                          {blockedusers && blockedusers.length <= 0 && (
                            <p className="empty-content-blocked-users red">
                              No Blocked Users
                            </p>
                          )}
                        </div>
                      </section>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </div>
        </div>
      )}
      {user && user.role === "employer" && (
        <div>
          {/* <LoggedInNavBlue /> */}
          <MinimumNav user={user} />
          <div className="flex-all-content-fixed">
            <section className="settings-main-body">
              <div className="active-view">
                <div
                  onClick={() =>
                    setView({
                      profile: true,
                      notifications: false,
                      privacy: false,
                      blockedusers: false,
                    })
                  }
                  className="section-title blue"
                >
                  Profile
                  {view.profile && (
                    <i className="far fa-check-circle mx-5 blue"></i>
                  )}
                </div>
                <div
                  onClick={() =>
                    setView({
                      profile: false,
                      notifications: true,
                      privacy: false,
                      blockedusers: false,
                    })
                  }
                  className="section-title blue"
                >
                  Notifications
                  {view.notifications && (
                    <i className="far fa-check-circle mx-5 blue"></i>
                  )}
                </div>
                <div
                  onClick={() =>
                    setView({
                      profile: false,
                      notifications: false,
                      privacy: true,
                      blockedusers: false,
                    })
                  }
                  className="section-title blue"
                >
                  Privacy
                  {view.privacy && (
                    <i className="far fa-check-circle mx-5 blue"></i>
                  )}
                </div>
                <div
                  onClick={() =>
                    setView({
                      profile: false,
                      notifications: false,
                      privacy: false,
                      blockedusers: true,
                    })
                  }
                  className="section-title blue"
                >
                  Blocked Users
                  {view.blockedusers && (
                    <i className="far fa-check-circle mx-5 blue"></i>
                  )}
                </div>
              </div>
              <div className="option-setting-container blue">
                <div className="option-settings">
                  {view.profile && (
                    <div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Online Status</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select who can view your online status
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.onlinestatus &&
                                settings.onlinestatus.friends
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"settings_friends"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.onlinestatus &&
                                    settings.onlinestatus.friends
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Friends
                            </li>
                            <li
                              className={
                                settings.onlinestatus &&
                                settings.onlinestatus.anyone
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"settings_anyone"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.onlinestatus &&
                                    settings.onlinestatus.anyone
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Anyone
                            </li>
                            <li
                              className={
                                settings.onlinestatus &&
                                settings.onlinestatus.hidden
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"settings_hidden"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.onlinestatus &&
                                    settings.onlinestatus.hidden
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Hidden
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">
                            Auto-Renew Subscriptions
                          </div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select whether or not you would like all your
                              active subscriptions to auto-renew
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.autorenew && settings.autorenew.renew
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"settings_renew"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.autorenew &&
                                    settings.autorenew.renew
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.autorenew && !settings.autorenew.renew
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"settings_not_renew"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.autorenew &&
                                    !settings.autorenew.renew
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Delete Account</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              There is no turning back! You will lose all your
                              content!
                            </p>
                          </div>
                        </div>
                        <div
                          onClick={() => setShowDeleteAccount(true)}
                          className="setting-option-choices"
                        >
                          <ul className="option-choices">
                            <li className="option-choice-alt white">
                              <div className="check-text-container">
                                <i className="far fa-times-circle mx-5 x red"></i>
                              </div>
                              Delete Account
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                  {view.notifications && (
                    <div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Live Streams</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Be notified when users you follow or subscribe to
                              go live
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.livestreams
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_livestreams"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.livestreams
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.livestreams
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_livestreams"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.livestreams
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Mentions</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Be alerted when a user mentions you in a live chat
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.mentions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_mentions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.mentions
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.mentions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_mentions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.mentions
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Friend requests</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Be notified when you receive a new friend request,
                              or your friend request was accepted
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.friendrequests
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_friendrequests"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.friendrequests
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.friendrequests
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_friendrequests"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.friendrequests
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">
                            Expiring Subscriptions
                          </div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Receive notification for an expiring subscription
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.expiringsubscriptions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_expiringsubscriptions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.expiringsubscriptions
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.expiringsubscriptions
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_expiringsubscriptions"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications
                                      .expiringsubscriptions
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Shared Article</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Receive notification when a user shares an article
                              with you
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.sharedarticles
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_sharedarticles"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.sharedarticles
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.sharedarticles
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_sharedarticles"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.sharedarticles
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">New Follower</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Receive notification when you gain a new follower
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.notifications &&
                                settings.notifications.newfollower
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_newfollower"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    settings.notifications.newfollower
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.notifications &&
                                !settings.notifications.newfollower
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"notifications_not_newfollower"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.notifications &&
                                    !settings.notifications.newfollower
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                  {view.privacy && (
                    <div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Community Type</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select who can join and post in your community
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                profile && profile.publicprofile
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_profiletype_public"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    profile && profile.publicprofile
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Public
                            </li>
                            <li
                              className={
                                profile && profile.privateprofile
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_profiletype_private"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    profile && profile.privateprofile
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Private
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">
                            Two Factor Authentication (Recommended)
                          </div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Choose to require additional validation before
                              accessing your account.{" "}
                              <span className="red bold">
                                This setting is highly recommended.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.privacy && settings.privacy.TwoFA
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_TwoFA"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy && settings.privacy.TwoFA
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.privacy && !settings.privacy.TwoFA
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_not_TwoFA"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy && !settings.privacy.TwoFA
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Employer Messages</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select whether or not employers can message you
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.privacy &&
                                settings.privacy.employermessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_employermessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    settings.privacy.employermessages
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.privacy &&
                                !settings.privacy.employermessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_not_employermessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    !settings.privacy.employermessages
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Mentor Messages</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select whether or not mentor can message you
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.privacy &&
                                settings.privacy.mentormessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_mentormessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    settings.privacy.mentormessages
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.privacy &&
                                !settings.privacy.mentormessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_not_mentormessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    !settings.privacy.mentormessages
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="option-setting">
                        <div className="options-left">
                          <div className="setting-name">Follower Messages</div>
                          <div className="setting-info">
                            <p className="setting-description">
                              Select whether or not followers can message you
                            </p>
                          </div>
                        </div>
                        <div className="setting-option-choices">
                          <ul className="option-choices">
                            <li
                              className={
                                settings.privacy &&
                                settings.privacy.followermessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_followermessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    settings.privacy.followermessages
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              On
                            </li>
                            <li
                              className={
                                settings.privacy &&
                                !settings.privacy.followermessages
                                  ? "option-choice selected-option"
                                  : "option-choice"
                              }
                              value={"privacy_not_followermessages"}
                              onClick={(e) =>
                                updateSetting(
                                  e.currentTarget.attributes.value.value
                                )
                              }
                            >
                              <div className="check-text-container">
                                <i
                                  className={
                                    settings.privacy &&
                                    !settings.privacy.followermessages
                                      ? "fas fa-check mx-5 blue"
                                      : "fas fa-check mx-5 hide-check"
                                  }
                                ></i>
                              </div>
                              Off
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                  {view.blockedusers && (
                    <div>
                      {blockedusers && blockedusers.length > 0 && (
                        <div className="user-search-container">
                          <div className="article-search-container">
                            <form action="" className="trending-form-flex">
                              <div className="label-input">
                                <label
                                  htmlFor=""
                                  className="trending-labels blue"
                                >
                                  Search
                                  <i className="fas fa-search blue mx-5"></i>
                                </label>
                                <div className="input-drop-down">
                                  <div className="search-input-hidden">
                                    <input
                                      className="search-input-style"
                                      type="text"
                                      name="mentors"
                                      placeholder="Enter User Name..."
                                    />
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      )}
                      <section className="setting-friends-section">
                        <div className="setting-friend-results">
                          {blockedusers &&
                            blockedusers.map((friend) => (
                              <BlockedUserItem
                                key={friend._id}
                                friend={friend}
                                setUnblockUser={setUnblockUser}
                              />
                            ))}
                          {blockedusers && blockedusers.length <= 0 && (
                            <p className="empty-content-blocked-users blue">
                              No Blocked Users
                            </p>
                          )}
                        </div>
                      </section>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </div>
        </div>
      )}
    </Fragment>
  );
};

Settings.propTypes = {
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  blockuser: PropTypes.object.isRequired,
  getSettings: PropTypes.func.isRequired,
  getProfileById: PropTypes.func.isRequired,
  getBlockedUsers: PropTypes.func.isRequired,
  updateSetting: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  clearMsg: PropTypes.func.isRequired,
  deleteAccount: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
  setting: state.setting,
  blockuser: state.blockuser,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getSettings,
  updateSetting,
  getProfileById,
  getBlockedUsers,
  logout,
  clearMsg,
  deleteAccount,
})(Settings);
